import React from "react";
import { useTranslation } from "react-i18next";

import { Box } from "ds/Box";
import { Modal } from "ds/Modal";
import { Heading, Paragraph } from "ds/Typography";
import { useConnectionStatus } from "hooks/useConnectionStatus";

import { BrokenHeartIcon } from "./BrokenHeartIcon";

const OFFLINE_DETECTION_TIMEOUT = 3000;

export const ConnectionLost = () => {
  const { t } = useTranslation();
  const { shouldShowOfflineModal } = useConnectionStatus({
    offlineDelay: OFFLINE_DETECTION_TIMEOUT,
  });

  return (
    <Modal visible={shouldShowOfflineModal} style={{ maxWidth: 400, minWidth: 300 }}>
      <Box justifyContent="center" alignItems="center" flexDirection="column" textAlign="center" gap="200">
        <Box height={128} width={128}>
          <BrokenHeartIcon />
        </Box>
        <Heading level="h4">{t("connection-lost.title")}</Heading>
        <Paragraph preset="caption100">{t("connection-lost.description")}</Paragraph>
      </Box>
    </Modal>
  );
};
